import { z } from 'zod/v4'
import { paginationLinksSchema, paginationMetaSchema } from '@/lib/schema/v2/pagination'
import { zDayJs } from '@/lib/schema/v2/dayjs'
import { ampApiErrorSchema } from '@/lib/schema/v2/amp-api-response'

export const ticketDepartmentSchema = z.object({
    created_at: zDayJs.nullish(),
    description: z.string().nullish(),
    name: z.string().nullish(),
    priority: z.number().nullish(),
    title: z.string().nullish(),
    updated_at: zDayJs.nullish(),
    uuid: z.uuid().nullish(),
})

export const ticketDepartmentsSchema = z.array(ticketDepartmentSchema)

export const paginatedTicketDepartmentsResponseSchema = z.object({
    data: ticketDepartmentsSchema.nullish(),
    links: paginationLinksSchema.nullish(),
    meta: paginationMetaSchema.nullish(),
    success: z.boolean(),
    error: ampApiErrorSchema.nullish(),
})

export const retrieveTicketDepartmentResponseSchema = z.object({
    data: ticketDepartmentSchema.nullish(),
    success: z.boolean(),
    error: ampApiErrorSchema.nullish(),
})

export const ticketDepartmentUpdateFormSchema = z.object({
    ticket_uuid: z.uuid(),
    title: z.string(),
    parent_uuid: z.uuid().nullable(),
})

export type PaginatedTicketDepartmentsResponse = z.infer<
    typeof paginatedTicketDepartmentsResponseSchema
>
export type TicketDepartmentUpdateForm = z.infer<typeof ticketDepartmentUpdateFormSchema>
export type TicketDepartment = z.infer<typeof ticketDepartmentSchema>
export type TicketDepartments = z.infer<typeof ticketDepartmentsSchema>
export type RetrieveTicketDepartmentResponse = z.infer<
    typeof retrieveTicketDepartmentResponseSchema
>
